import { render, staticRenderFns } from "./ShutDownDueToOverallLosses.vue?vue&type=template&id=6781128c&scoped=true"
import script from "./ShutDownDueToOverallLosses.vue?vue&type=script&lang=js"
export * from "./ShutDownDueToOverallLosses.vue?vue&type=script&lang=js"
import style0 from "./ShutDownDueToOverallLosses.vue?vue&type=style&index=0&id=6781128c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6781128c",
  null
  
)

export default component.exports